/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import { TitleActions } from '../actions/titleActions';
import { IState } from '../store/types/StateTypes';
import { IReducerAction } from '../store/types/ReducerTypes';

export default function titleComponentReducers(state: IState, action: IReducerAction<any>) {
    let newState = state;

    if (action.type === TitleActions.VISUALIZATION_TITLE_CHANGE) {
        newState = {
            ...state,
            titleOptions: {
                ...state.titleOptions,
                title: action.data.title
            }
        };
    }

    if (action.type === TitleActions.VISUALIZATION_TITLE_CHANGE_EDITING_MODE) {
        newState = {
            ...state,
            titleOptions: {
                ...state.titleOptions,
                inEditingMode: action.data.inEditingMode
            }
        };
    }

    if (action.type === TitleActions.VISUALIZATION_HEIGHT_CHANGE) {
        newState = {
            ...state,
            titleOptions: {
                ...state.titleOptions,
                domNodeHeight: action.data.height
            }
        };
    }

    return newState;
}
